
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Concejo extends Vue {
  private mediaUrl = process.env.VUE_APP_MEDIA_URL;
  private menu = [];
  private menuLateral: any = [];
  private nombreWeb: any = "";
  private listaConcejales = [
    {
      nombre: "Bladymir Muñoz Acevedo",
      email: "concejalmunoz@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/1-BLADYMIR-MUNOZ.jpg"
    },
    {
      nombre: "Karen Garrido Neira",
      email: "concejalagarrido@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/2-KAREN-GARRIDO.jpg"
    },
    {
      nombre: "Edison Aguilera Salazar",
      email: "concejalaguilera@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/3-EDISON-AGUILERA.jpg"
    },
    {
      nombre: "Ka Quiroz Viveros",
      email: "concejalaquiroz@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/4-KA-QUIROZ.jpg"
    },
    {
      nombre: "Nicolás Carrancio Fuentes",
      email: "concejalcarrancio@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/5-NICOLAS-CARRANCIO.jpg"
    },
    {
      nombre: "Felipe Farías López",
      email: "concejalfarias@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/6-FELIPE-FARIAS.jpg"
    },
    {
      nombre: "Horacio Saavedra Núñez",
      email: "concejalsaavedra@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/7-HORACIO-SAAVEDRA.jpg"
    },
    {
      nombre: "Ariel Ramos Stocker",
      email: "concejalramos@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/8-ARIEL-RAMOS.jpg"
    },
    {
      nombre: "Juan Carlos Prado Chacón",
      email: "concejalprado@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/9-JUAN-CARLOS-PRADO.jpg"
    },
    {
      nombre: "Graciela Arochas Felber",
      email: "concejalaarochas@maipu.cl",
      foto: process.env.VUE_APP_MEDIA_URL + "/Concejo/10-GRACIELA-AROCHAS.jpg"
    }
  ];

  private beforeMount() {}
  private mounted() {
    document.title = "Concejo Municipal - Municipalidad de Maipú";
    this.setMenu();
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private async setMenu() {
    const runtimeConfig1 = await fetch("/menu_maipu.json");
    this.menu = await runtimeConfig1.json();
    for (let i = 0; i < this.menu.length; i++) {
      if (this.getSubMenu(this.menu[i], "concejo-municipal", 1)) {
        this.menuLateral = (this.menu[i] as any).sub_menu;
        this.checkSubMenus();
        break;
      }
    }
  }

  private getSubMenu(element: any, nombre_web: string, profundidad) {
    if (element.nombre_web == nombre_web) {
      return true;
    } else {
      if (element.sub_menu && element.sub_menu.length > 0) {
        for (let j = 0; j < element.sub_menu.length; j++) {
          if (
            this.getSubMenu(element.sub_menu[j], nombre_web, profundidad + 1)
          ) {
            return true;
          }
        }
      }
      return false;
    }
  }

  private selectedStyle(item: any) {
    if ("concejo-municipal" == item.nombre_web) {
      item.expand = true;
      return " background-color: #10174a !important; color: #f1f1f1 !important;font-family: 'RubikBold' !important;";
    } else {
      let childSelected = false;
      if (item.sub_menu && item.sub_menu.length > 0) {
        for (let i = 0; i < item.sub_menu.length; i++) {
          if ("concejo-municipal" == item.sub_menu[i].nombre_web) {
            childSelected = true;
          }
        }
        if (childSelected) {
          item.expand = true;
          return " background-color: #10174a !important; color: #f1f1f1 !important;font-family: 'RubikBold' !important;";
        }
      }
      return "";
    }
  }

  private checkSubMenus() {
    for (let i = 0; i < this.menuLateral.length; i++) {
      if (this.menuLateral[i].sub_menu.length > 0) {
        if (
          this.menuLateral[i].tipo == 2 &&
          "concejo-municipal" == this.menuLateral[i].nombre_web
        ) {
          this.menuLateral[i].expand = true;
        } else {
          for (let j = 0; j < this.menuLateral[i].sub_menu.length; j++) {
            if (
              this.menuLateral[i].sub_menu[j].nombre_web == "concejo-municipal"
            ) {
              this.menuLateral[i].expand = true;
              break;
            }
          }
        }
      } else {
        this.menuLateral[i].expand = false;
      }
    }
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target);
    } else {
      return;
    }
  }
  private irPagina(nombreWeb: any) {
    if (nombreWeb == "contacto") {
      this.routerGo("Contacto");
    } else if (nombreWeb == "concejo-municipal") {
      this.routerGo("Concejo");
    } else {
      if (nombreWeb && nombreWeb != "") {
        if (
          this.$router.currentRoute.name == "Pagina" &&
          this.$router.currentRoute.params.nombre &&
          this.$router.currentRoute.params.nombre == nombreWeb
        ) {
          this.$router.go(0);
        } else {
          if (this.$router.currentRoute.name == "Pagina") {
            if (
              this.$router.currentRoute.params.nombre &&
              this.$router.currentRoute.params.nombre != nombreWeb
            ) {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
              this.$router.go(0);
            } else {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
            }
          } else {
            this.$router
              .push({ name: "Pagina", params: { nombre: nombreWeb } })
              .catch(err => {
                console.log(err);
              });
          }
        }
      }
    }
  }

  private sendMail(correo: string) {
    window.open("mailto:" + correo);
  }
}
